module.exports = __webpack_public_path__ + "img/xjfhcl.a0f1eba.png";